import React from "react"
import classNames from "classnames"
import { useStaticQuery, graphql } from "gatsby"

import Figure from "./figure"
import RichText from "./richText"

import styles from "./hero.module.scss"

const Hero = props => {
  const site = useStaticQuery(
    graphql`
      {
        sanitySiteConfig {
          boldTitle
        }
      }
    `
  )

  const { sanitySiteConfig: config } = site
  const isBold = config.boldTitle

  return (
    <div
      className={classNames(
        styles.hero,
        props.className,
        props.isGrcTheme && styles.grcTheme
      )}
      data-theme={props.theme ? props.theme : "new-hero-design"}
    >
      <div className="grid">
        <div
          className={classNames(
            "gridItem",
            props.gridParams || "xlarge-10 xlarge-offset-1"
          )}
        >
          <div className={styles.heroInner}>
            <div>
              {props.children}
              {props.logo && <Figure {...props.logo} />}
              <h1 className={isBold && styles.boldTitle}>{props.title}</h1>
              {props.description ? (
                <div className={styles.description}>
                  <RichText blocks={props.description} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
